var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view404"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.errorCode))])])
}
var staticRenderFns = []

export { render, staticRenderFns }